<template>
  <div class="index-layout" :class="{'is-mobile':isMobile,'is-android':isAndroid,'is-ios':isIos,'is-pc':isPc}">
    <div class="scroll-box" @scroll="scrollTrigger">
      <div class="slide-inner" :style="'width:'+layoutWidth">
        <div ref="layout" v-if="dataReady">
          <!-- 产品信息 -->
          <card class="card-mainInfo" :size="productCard.size" :styleObject="productCard.styleObject">
            <div slot="content" class="showcase-circle">
              <swiper :slides="productCard.images"></swiper>
            </div>
            <p slot="content" class="info">
              <span v-if="productCard.info" class="product-card-info">
                <span v-html="productCard.info" class="product-card-info-text"></span>
                <poor-tag slot="content"></poor-tag>
              </span>
            </p>
            <p slot="content" class="subInfo" v-html="productCard.subInfo"></p>

          </card>
          <!-- 品控 -->
          <card class="card-controls" v-for="(cardItem,index) in productControls" :key="index" :size="cardItem.size"
                :styleObject="cardItem.styleObject">
            <div slot="content">
              <p class="left-title">{{cardItem.leftTitle}}</p>
              <p class="left-subTitle">{{cardItem.leftSubTitle}}</p>
              <div class="content-image" :style="{backgroundImage:'url('+cardItem.image+')'}"></div>
              <p class="info" v-html="cardItem.info"></p>
              <p class="subInfo" v-html="cardItem.subInfo"></p>
            </div>
          </card>
          <!-- 产品详情 -->
          <card class="card-details" :size="productDetails.size" :styleObject="productDetails.styleObject">
            <div slot="head">{{productDetails.title}}</div>
            <div slot="content" class="card-content-fixed">
              <div class="slide-detail">
                <ul>
                  <li v-for="(item,index) in productDetails.list" :key="index" v-if="item.content"
                      class="card-details-item zoom">
                    <span class="detail-title">{{item.title}}</span>
                    <span class="detail-content" :class="{'org-detail-link':item.title == '所属企业'}" @click.prevent="detailContentClickHandler(item)">
                      <span v-if="item.title == '产品身份证' && item.productCode">{{item.productCode}}<br /></span>
                      <span v-if="item.productAuthentication==1">
                        <span v-for="(text,index) in item.content" style="margin-right: 15px;display: inline-block" :key="index">{{text}}</span>
                      </span>
                      <span v-if="item.productAuthentication!=1">{{item.content}}</span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </card>
          <!-- 区块链信息 -->
          <card class="card-blockchain" :size="blockchain.size" :styleObject="blockchain.styleObject">
            <div slot="head">
              {{blockchain.title}}
              <!--<div class="blockchain-subTitle">信息由<span style="display: inline-block;"><i-->
              <!--class="block-icon"></i>满天星区块链</span>技术认证-->
              <!--</div>-->
            </div>
            <div slot="content" class="card-content-fixed">
              <div class="slide-blockchain">
                <ul style="padding: 0 0.2rem 0 0">
                  <li v-for="(item,index) in blockchain.list" :key="index" v-if="item.content"
                      class="card-blockchain-item zoom">
                    <span class="blockchain-title">{{item.title}}</span>
                    <span class="blockchain-content">{{item.content}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </card>
          <!-- 天气 -->
          <card class="card-weather" v-if="weather"
                @mousedown.native="weatherDown" @mouseup.native="weatherUp"
                @touchmove.native="weatherMove" @mousemove.native="weatherMove"
                @touchstart.native="weatherDown" @touchend.native="weatherUp"
                :size="weather.size" :styleObject="weatherStyle">
            <div slot="content" class="content-image" :style="{backgroundImage:'url('+weather.image+')'}"></div>
            <p slot="content" class="info" v-html="weather.info"></p>
            <p slot="content" class="subInfo" v-html="weather.subInfo"></p>
            <div slot="head" v-if="weatherAllowed" class="weather-more">更多</div>
          </card>
          <!-- 二维码 -->
          <card class="card-qrcode" :size="QRCode.size" :styleObject="QRCode.styleObject">
            <div slot="content" class="content-image" :style="{backgroundImage:'url('+QRCode.image+')'}"></div>
            <p slot="content" class="info" v-html="QRCode.info"></p>
            <p slot="content" class="subInfo" v-html="QRCode.subInfo"></p>
          </card>
          <!-- 可以使用公共结构的 -->
          <div class="card-wrap" v-for="(cardItem,index) in cardList" @click.prevent="clickCard(index)">
            <card onselectstart="return false;" @click.prevent="clickCard(index)" cancelable="false"
                  class="card-item-touch" :data-index="index" :key="index" :size="cardItem.size"
                  :styleObject="cardItem.styleObject">
              <div slot="content" class="center-content" @click.prevent="clickCard(index)">
              <span class="card-links" @click.prevent="clickCard(index)">
                <div class="content-icon iconfont" :class="cardItem.icon"
                     :style="cardItem.iconUrl?{backgroundImage: 'url('+cardItem.iconUrl+')'}:{}"></div>
                <div class="">{{cardItem.info}}</div>
              </span>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import card from '@/components/common/card.vue'
  import poorTag from '@/components/common/poorTag.vue'
  import swiper from '@/components/composite/swiper'
  import { mapState } from 'vuex'
  import cardsStyle from '@/enums/cardStyle.js'
  import enums from '@/enums/index.js'
  import envConfig from '@/config/env.js'
  import breakLines from '@/utils/breakLinesForCanvas.js'

  const traceCard = {
    'size': 'normal',
    'info': '溯源信息',
    'type': 'trace',
    'icon': 'icon-loop',
    'linksTo': '',
    'path': 'detailInfo',
    'styleObject': { backgroundColor: '#01a21b' }
  }
  const selfTestCard = {
    'size': 'normal',
    'info': '检测信息',
    'type': 'testReport',
    'icon': 'icon-info',
    'linksTo': '',
    'path': 'detailInfo',
    'styleObject': { backgroundColor: '#2f87ee' }
  }
  const plotsCard = {
    'size': 'normal',
    //'info': '地块信息',
    'info': '基地信息',
    'type': 'plots',
    'icon': 'icon-geo',
    'linksTo': '',
    'path': 'map',
    'styleObject': { backgroundColor: '#613ebc' }
  }
  const otherTestCard = {
    'size': 'normal',
    'info': '第三方检测',
    'type': 'thirdParty',
    'icon': 'icon-tripartite',
    'linksTo': '',
    'path': 'detailInfo',
    'styleObject': { backgroundColor: '#db572e' }
  }
  const insuranceClaimsCard = {
    'size': 'normal',
    'info': '保险理赔',
    'type': 'insuranceClaims',
    'icon': 'icon-insurance',
    'linksTo': '',
    'path': 'detailInfo',
    'styleObject': { backgroundColor: '#2f87ee' }
  }

  export default {
    data() {
      let isMobile = false;
      let isAndroid = false;
      let isIos = false;
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        isMobile = true;
        isIos = true;
      } else if (/(Android)/i.test(navigator.userAgent)) {
        isMobile = true;
        isAndroid = true;
      }
      return {
        weatherAllowed: false,
        dataReady: false,
        weatherTouched: false,
        weatherMoved: false,
        blockchainOn: true,
        isMobile, isAndroid, isIos, isPc: !isMobile,
        resultData: {},
        blockchainData: {},
        resultCustomFunctionData: {},
        layoutWidth: '',
        productCard: {
          'size': 'max',
          'images': [],
          'info': '产品名称',
          'subInfo': '产品副标题',
          'styleObject': {}
        },
        isRouterLinkIng: false,
        isTouchMoved: false,
        touchTriggerTime: 0,
        touchXY: { x: 0, y: 0 },
        utTimeOut: null,
        isOnlyTouchStart: false,
        iotsTomeOut: null,
        scrollTimeOut: null,
        productBatchID: '',
        // productControls: [
        //   {
        //     'size': 'normal',
        //     'leftTitle': '品控安保',
        //     'leftSubTitle': '第三方检测',
        //     'image': 'url("")',
        //     'info': '德国莱茵TUV',
        //     'subInfo': '全球权威检测认证机构',
        //     'styleObject': {backgroundColor: '#db572b'}
        //   },
        //   {
        //     'size': 'normal',
        //     'leftTitle': '品控安保',
        //     'leftSubTitle': '第三方检测',
        //     'image': 'url("")',
        //     'info': '德国莱茵TUV',
        //     'subInfo': '全球权威检测认证机构',
        //     'styleObject': {backgroundColor: '#01a21b'}
        //   }
        // ],
        productControls: [],
        productDetails: {
          'size': 'large',
          'title': '产品详情',
          'list': [],
          'styleObject': { backgroundColor: '#d1462f' }
        },
        weather: {
          'size': 'normal',
          'info': '县域',
          'subTitle': '天气情况',
          'image': 'none',
          'styleObject': { backgroundColor: '#613ebc' }
        },
        blockchain: {
          'size': 'large',
          'title': '满天星区块链',
          'list': [],
          'styleObject': { backgroundColor: '#8531de' }
        },
        QRCode: {
          'size': 'normal',
          'info': '扫描二维码，查看手机版',
          'image': 'static/qrcode.png',
          'styleObject': { backgroundColor: '#db572e' }
        },
        cardList: []
      }
    },
    /*watch: {
     cardList: {
     handler: function () {
     this.changeGestureState();
     },
     deep: true
     },
     layoutWidth: {
     handler: function () {
     this.changeGestureState();
     },
     deep: true
     }
     },*/
    computed: mapState({
      htmlFontSize: state => state.htmlFontSize,
      indexCardsSize: function (state) {
        return state.indexCardsSize
      },
      weatherStyle() {
        const style = JSON.parse(JSON.stringify(this.weather.styleObject));
        if (this.weatherTouched) {
          style.backgroundColor = this.color2rgba(style.backgroundColor, 0.5);
        }
        return style
      }
    }),
    components: {
      card,
      swiper,
      poorTag
    },
    methods: {
      detailContentClickHandler(item) {
        if (item.title === '所属企业') {
          this.routerLink({ path: 'detailInfo', query: { type: 'orgDetail', name: '企业详情' } });
        }
      },
      async loadStationList() {
        const resultData = JSON.parse(localStorage.resultData);
        const Code = resultData.BatchData.Code;
        const Token = await this.getToken();
        const result = await this.$ajax.jsonp(this.$urlAPI.BaseData.GetWeatherStationList, { Code, Token });
        let stationList = [];
        if (result.Result == 200 && result.Data && result.Data.RecordList) {
          stationList = result.Data.RecordList;
        }
        return stationList;
      },
      async getToken() {
        const result = await this.$ajax.get(this.$urlAPI.BaseData.getAndroidToken);
        const token = result.Data.token;
        return token;
      },
      async setWeatherAllowed() {
        const stationList = await this.loadStationList();
        this.weatherAllowed = stationList.length > 0;
      },
      weatherDown() {
        if (this.weatherAllowed) {
          this.weatherTouched = true;
          this.weatherMoved = false;
        }
      },
      weatherUp() {
        if (this.weatherAllowed) {
          this.weatherTouched = false;
          if (!this.weatherMoved) {
            this.viewWeatherInfo();
          }
        }
      },
      weatherMove() {
        if (this.weatherTouched) {
          setTimeout(() => {
            this.weatherMoved = true;
          }, 200);
        }
      },
      viewWeatherInfo() {
        this.routerLink({ path: 'weatherInfo' });
      },
      changeGestureState() {
        const boxWidth = this.$el.querySelector('.scroll-box').offsetWidth;
        const innerWidth = this.$el.querySelector('.slide-inner').offsetWidth;
        if (innerWidth > boxWidth) {
          this.$store.commit('changeGestureState', true);
        }
      },
      routerLink(params) {
        if (!this.isRouterLinkIng) {
          this.isRouterLinkIng = true;
          setTimeout(() => {
            this.isRouterLinkIng = false;
          }, 300);
          this.$router.push({ path: params.path, query: params.query });
        }
      },
      //  获取产品溯源信息数据
      getData() {
        this.resultData = JSON.parse(localStorage.getItem('resultData'));
        this.resultCustomFunctionData = JSON.parse(localStorage.getItem('resultCustomFunctionData'));
        this.distributeCardsInfo();
      },
      //  产品卡片信息
      setProductInfo(resultData = {}) {
        const productCard = this.productCard || {};
        productCard['images'] = [resultData.Product.Thumbnail1, resultData.Product.Thumbnail2, resultData.Product.Thumbnail3, resultData.Product.Thumbnail4, resultData.Product.Thumbnail5].filter((val, index, arr) => {
          if (val) {
            return val
          }
        });
        var titleInfo = breakLines.breakLinesForCanvas(resultData.Product.ProductName, this.htmlFontSize * 5.4, '24px 微软雅黑');
        if (titleInfo.length > 2) {
          titleInfo.splice(2, titleInfo.length, '...')
        }
        var subTitleInfo = breakLines.breakLinesForCanvas(resultData.Product.SubProductName, this.htmlFontSize * 5.4, '18px 微软雅黑');
        if (subTitleInfo.length > 2) {
          subTitleInfo.splice(2, subTitleInfo.length, '...')
        }
        productCard['info'] = titleInfo.join('');
        productCard['subInfo'] = subTitleInfo.join('');
      },
      // 产品详情
      setTraceDetail(resultData = {}) {
        let detailList = [];
        // 获取产品详情
        let productCode = '', subCode = '';
        if (resultData.BatchData.Code.length >= 32) {
          productCode = resultData.BatchData.Code.substring(0, 11);
          subCode = resultData.BatchData.Code.substring(11, resultData.BatchData.Code.length);
          detailList.push({ title: '产品身份证', productCode: productCode, content: subCode });
        } else {
          detailList.push({ title: '产品身份证', content: resultData.BatchData.Code });
        }
        if (resultData.BatchData.MarketTime) {
          detailList.push({
            title: '上市时间',
            content: resultData.BatchData.MarketTime.replace(/ \d{1,2}:\d{1,2}:\d{1,2}/g, '')
          });
        }
        const exitFields = resultData.Product.ExtFields;
        if (exitFields && exitFields.length > 0) {
          for (let k = 0; k < exitFields.length; k++) {
            const item = exitFields[k];
            detailList.push({ title: item.ItemKey, content: item.ItemValue });
          }
        }
        //农资产品
        if (resultData.Product.ProductName) {
          detailList.push({
            title: '产品名称',
            content: resultData.Product.ProductName
          });
        }
        if (resultData.Product.RegistratioCertificateNumber) {
          detailList.push({
            title: "登记证号",
            content: resultData.Product.RegistratioCertificateNumber
          });
        }
        if (resultData.Product.ProduceTypeName) {
          detailList.push({
            title: '生产类型',
            content: resultData.Product.ProduceTypeName
          });
        }
        if (resultData.Product.SpecificationCodeName) {
          detailList.push({
            title: "产品规格",
            content: resultData.Product.SpecificationCodeName
          });
        }
        detailList = this.productDetailFix(detailList, resultData);
        this.productDetails.list = detailList;
      },
      // 产品OID码 产品认证 保质期 所属企业
      productDetailFix(detailList, resultData) {
        const productOID = this.getProductOID(resultData);
        const productAuthenticationInfo = this.getProductAuthenticationInfo(resultData);
        const expiryDay = this.getExpiryDay(resultData);
        const corpName = this.getCorpName(resultData);
        productOID && detailList.push(productOID);
        productAuthenticationInfo && detailList.push(productAuthenticationInfo);
        expiryDay && detailList.push(expiryDay);
        corpName && detailList.push(corpName);
        return detailList;
      },
      //产品OID码
      getProductOID(resultData) {
        const { ProductOID } = resultData.Product;
        if (ProductOID) {
          const { Code } = resultData.BatchData;
          return { title: '产品OID码', content: ProductOID + '.' + Code };
        }
      },
      //产品认证
      getProductAuthenticationInfo(resultData) {
        const ProductAuthenticationItem = {
          1: '无公害', 5: '绿色', 10: '有机', 15: '地理标志',
          20: '生态原产地', 25: '三同', 30: '其他', 35: '无认证',
          40: 'Global G.A.P.'
        };
        const { ProductAuthentication } = resultData.Product;
        if (ProductAuthentication) {
          const items = ProductAuthentication.split(',');
          if (items.length > 0) {
            const content = items.map(code => ProductAuthenticationItem[code]);
            return {
              title: '产品认证',
              productAuthentication: 1,
              content
            };
          }
        }
      },
      //保质期
      getExpiryDay(resultData) {
        const { ExpiryDay, ExpiryDayUnit } = resultData.Product;
        if (ExpiryDay && ExpiryDayUnit) {
          return {
            title: "保质期",
            content: ExpiryDay + ExpiryDayUnit
          };
        }
      },
      getCorpName(resultData) {
        if (resultData.ProductOrgName) {
          return {
            title: "所属企业",
            content: resultData.ProductOrgName
          };
        }
      },
      // 区块链信息
      setBlockchain(resultData = {}) {
        this.blockchainData = JSON.parse(localStorage.getItem('blockchain'));
        const blockchainData = this.blockchainData;
        const blockchainList = [];
        if (blockchainData.Result == 200 && blockchainData.Data.BlockHash) {
          blockchainList.push(
            {
              title: '区块编号',
              content: blockchainData.Data.BlockNo
            }, {
              title: '区块Hash',
              content: blockchainData.Data.BlockHash
            }, {
              title: '上证时间',
              content: new Date(parseInt(blockchainData.Data.TransactionTime) / 1000000).toLocaleString().replace(/ \d{1,2}:\d{1,2}:\d{1,2}/g, '')
            }, {
              title: '追溯编码',
              content: blockchainData.Code
            });
        } else if (blockchainData.Result != 200 || !blockchainData.Data.BlockHash) {
          this.blockchainOn = false;
          setTimeout(function () {
            document.getElementsByClassName('card-blockchain')[0].style.visibility = "hidden";
          }, 200);
          this.layout();
        }
        this.blockchain.list = blockchainList;
      },
      // 设置天气数据
      setWeather() {
        const weatherInfo = JSON.parse(localStorage.getItem('resultWeatherData')) || {};
        if (weatherInfo.Result && weatherInfo.Data && weatherInfo.Data.town) {
          this.weather['info'] = weatherInfo.Data.town;
          this.weather['subInfo'] = '<p><span style="display:inline-block;margin-right: 0.12rem;font-size:30px;">' + weatherInfo.Data.temperature + '℃</span>' + weatherInfo.Data.weather + '</p>';
          this.weather['image'] = weatherInfo.Data.weather_pic;
        } else {
          this.weather = null;
        }
      },
      // 是否有 莱茵品控/溯源/检测/地块/第三方/保险理赔/自定义 卡片
      setCardsList(resultData = {}) {
        // 溯源信息
        if (resultData && resultData.ProductBatchID && resultData.TraceNodesCount > 0) {
          localStorage.setItem('traceingBatchID', resultData.ProductBatchID);
          this.cardList.push(traceCard);
        }

        let selfTestData = [];
        let otherTestData = []; // 布局需要，两个检测之间插入地块
        // 检测信息
        if (resultData && resultData.TraceCheckStatus == 1) {
          if (resultData.TestingNodes && resultData.TestingNodes.length) {
            const testNodes = resultData.TestingNodes;
            testNodes.forEach((node, index) => {
              if (node.CheckedCorpID == node.CorpID) {
                selfTestData.push(node);
              } else {
                otherTestData.push(node);
              }
            });
          }
        }
        if (selfTestData.length) {
          localStorage.setItem('selfTestData', JSON.stringify(selfTestData));
          this.cardList.push(selfTestCard);
        }
        // 地块信息
        if (resultData.TraceNodes && resultData.TraceNodes.length > 0) {
          for (var i = 0; i < resultData.TraceNodes.length; i++) {
            var node = resultData.TraceNodes[i];
            if (node.TraceNodeType == 2) {
              localStorage.setItem('plotsData', node.TraceNodeContent);
              this.cardList.push(plotsCard);
              break;
            }
          }
        }
        if (otherTestData.length) {
          localStorage.setItem('otherTestData', JSON.stringify(otherTestData));
          this.cardList.push(otherTestCard);
        }
        // 保险理赔
        //如果码有关联保险且投保没有过期或者是开启保险理赔的特殊企业
        if ((resultData.isRelatedInsurance == 1 && resultData.isInsuranceOverdue == 0) || (resultData.CorpInfo.CorpID == envConfig.specialCorpClaimConfig.zhongNing.corpID || resultData.CorpInfo.CorpID == envConfig.specialCorpClaimConfig.hengShan.corpID || resultData.CorpInfo.CorpID == envConfig.specialCorpClaimConfig.daWa.corpID && resultData.isInsurance == 1)) {
          this.cardList.push(insuranceClaimsCard);
        }
        // 自定义
        if (this.resultCustomFunctionData && this.resultCustomFunctionData.length) {
          const resultCustomFunctionData = this.resultCustomFunctionData.sort((p, c) => {
            return p.SortID - c.SortID
          });
          const customizeCardClass = cardsStyle.cardClass;
          const customizeCardClassLength = customizeCardClass.length;
          resultCustomFunctionData.forEach((val, index, arr) => {
            this.cardList.push({
              'size': 'normal',
              'info': val.IcoName,
              'type': 'customize',
              'icon': 'icon-customize ' + customizeCardClass[index % customizeCardClassLength],
              'iconUrl': null,
              'linksTo': val.DataUrl,
              'path': 'iframe',
              'styleObject': {}
            });
          });
        }

        // 莱茵tuv+ 中国平安
        this.productControls[0] ? this.productControls[0]['image'] = 'static/tuv.png' : ''
        this.productControls[1] ? this.productControls[1]['image'] = 'static/zgpa.png' : ''
        // 二维码
        this.QRCode.image = envConfig.generatorQR + encodeURIComponent(envConfig.H5Url + resultData.BatchData.Code)
      },
      // 分发产品溯源数据
      distributeCardsInfo() {
        const resultData = this.resultData;
        this.setCardsList(resultData);
        this.setProductInfo(resultData);
        this.setTraceDetail(resultData);
        this.setBlockchain(resultData);
        this.setWeather();
        setTimeout(this.layout(), 200);
      },
      resetRemRootSize() {
        this.$store.commit('resizeCardsSize');
      },
      layout() {
        let sCards = [
          this.productCard,
          ...this.productControls,
          this.productDetails,
          this.blockchain,
          this.weather,
          this.QRCode,
          ...this.cardList
        ];
        let [maxCards, largeCards, normalCards] = [[], [], []];
        sCards = sCards.filter((item, index) => {
          if (item) {
            const size = item.size;
            switch (size) {
              case 'max':
                maxCards.push(item);
                break;
              case 'large':
                largeCards.push(item);
                break;
              case 'normal':
                normalCards.push(item);
                break;
              default:
                break;
            }
          }
          return item;
        });
        // 下面的插入其实都是把max与large当成只有一个元素的情况来处理了
        sCards = normalCards;
        sCards.splice(0, 0, ...maxCards);
        sCards.splice(1, 0, ...[null, null, null]);
        this.productControls.length ? (sCards.splice(6, 0, ...largeCards), sCards.splice(8, 0, null)) : (sCards.splice(4, 0, ...largeCards), sCards.splice(5, 0, null));
        const blockchainCard = sCards.find(item => item && (item.title === '满天星区块链' && item.size === 'large'));
        if (blockchainCard) {
          sCards.push(null);
        }
        let HorizontalNum = Math.ceil(sCards.length / 2);
        const customizeCardColor = cardsStyle.cardBackgroundColor;
        const customizeCardColorLength = customizeCardColor.length;
        sCards.forEach((item, index) => {
          if (item) {
            const temp = this.indexCardsSize['normal'];
            if (index % 2) {
              if (this.blockchainOn == true) {
                item.styleObject['top'] = temp.height + temp.margin + 'rem'
                item.styleObject['left'] = 3 + (temp.width + temp.margin) * (index - 1) / 2 + 'rem'
              } else if (this.blockchainOn == false) {
                item.styleObject['top'] = temp.height + temp.margin + 'rem'
                item.styleObject['left'] = (temp.width + temp.margin) * (index - 1) / 2 - 3 + 'rem'
              }

            } else {
              item.styleObject['top'] = 0;
              item.styleObject['left'] = (temp.width + temp.margin) * index / 2 + 'rem';
            }
            if (item.size == 'normal') {
              item.styleObject['backgroundColor'] = customizeCardColor[index % customizeCardColorLength];
            }
            item.styleObject['width'] = this.indexCardsSize[item.size].width + 'rem'
            item.styleObject['height'] = this.indexCardsSize[item.size].height + 'rem'
          }
        });
        const w = this.indexCardsSize['normal'];
        this.layoutWidth = (w.width + w.margin) * HorizontalNum * this.htmlFontSize - 10 + 'px';
      },
      getCardsDoms() {
        return this.$refs.layout ? this.$refs.layout.querySelectorAll('.card-item-touch') : [];
      },
      bindTouchMove(e) {
        if (e) {
          let moveX = '';
          let moveY = '';
          if (e.screenX && e.screenY) {
            moveX = e.screenX;
            moveY = e.screenY;
          } else if (e.changedTouches) {
            moveX = e.changedTouches[0].screenX;
            moveY = e.changedTouches[0].screenY;
          }
          const moveAbsX = Math.abs(this.touchXY.x - moveX);
          const moveAbsY = Math.abs(this.touchXY.y - moveY);
          //document.querySelector('.slide-detail').style.fontSize = '15px';
          this.logText('.slide-detail', `moveAbsX:${moveAbsX}  moveAbsY:${moveAbsY}   moveX:${moveX}  moveY:${moveY}   touchX:${this.touchXY.x}   touchY:${this.touchXY.y}`);
          //100ms内移动距离超过200px
          const now = Date.now();
          if (now - this.touchTriggerTime < 100 && (moveAbsX > 200 || moveAbsY > 200)) {
            return;
          }
          if (moveAbsX > 20 || moveAbsY > 20) {
            this.isTouchMoved = true;
            this.logText('.title', 'move:true');
          }
        }
        if (this.isTouchMoved) {
          this.isOnlyTouchStart = false;
        }
      },
      logText(selector, text) {
        try {
          //document.querySelector(selector).innerText = text;
        } catch (e) {
          console.error(e);
        }
      },
      bindTouch() {
        const cards = this.getCardsDoms();
        for (let i = 0, len = cards.length; i < len; i++) {
          cards[i].addEventListener(enums.Events.touchStart, this.touchTrigger);
          cards[i].addEventListener(enums.Events.touchEnd, this.unTouchTrigger);
          cards[i].addEventListener('touchcancle', this.unTouchTrigger);
        }
        if (this.$refs.layout) {
          this.$refs.layout.addEventListener(enums.Events.touchEnd, this.unTouchTrigger);
          this.$refs.layout.addEventListener('touchcancle', this.unTouchTrigger);
        }
      },
      unbindTouch() {
        const cards = this.getCardsDoms();
        for (let i = 0, len = cards.length; i < len; i++) {
          cards[i].removeEventListener(enums.Events.touchStart, this.touchTrigger);
          cards[i].removeEventListener(enums.Events.touchEnd, this.unTouchTrigger);
          cards[i].removeEventListener('touchcancle', this.unTouchTrigger);
        }
        if (this.$refs.layout) {
          this.$refs.layout.removeEventListener(enums.Events.touchEnd, this.unTouchTrigger);
          this.$refs.layout.removeEventListener('touchcancle', this.unTouchTrigger);
        }
      },
      color2rgba(color, opc) {
        let red = '', green = '', blue = '';
        if (color.indexOf('#') === 0) {
          //#rrggbb
          const c = color.replace('#', '').split('');
          red = parseInt(c[0] + c[1], 16);
          green = parseInt(c[2] + c[3], 16);
          blue = parseInt(c[4] + c[5], 16);
        } else if (color.indexOf('rgb(') === 0) {
          //rgb(r,g,b)
          [red, green, blue] = color.replace('rgb(', '').replace(')', '').split(',').map(item => item.trim());
        } else if (color.indexOf('rgba(') === 0) {
          //rgba(r,g,b,opc)
          [red, green, blue] = color.replace('rgba(', '').replace(')', '').split(',').map(item => item.trim());
        }
        return `rgba(${red},${green},${blue},${opc})`;
      },
      touchTrigger(event) {
        let cardDom = event.target;
        //----
        let touchX = '';
        let touchY = '';
        if (event.screenX && event.screenY) {
          touchX = event.screenX;
          touchY = event.screenY;
        } else if (event.changedTouches) {
          touchX = event.changedTouches[0].screenX;
          touchY = event.changedTouches[0].screenY;
        }
        this.touchXY.x = touchX;
        this.touchXY.y = touchY;
        this.isTouchMoved = false;
        this.isOnlyTouchStart = true;
        this.touchTriggerTime = Date.now();
        this.logText('.title', 'move:false');
        this.logText('.info', 'touchstart');
        //----
        while (cardDom.className.indexOf('card-item-touch') < 0) {
          cardDom = cardDom.parentNode;
        }
        const index = cardDom.getAttribute('data-index') * 1;
        const style = this.cardList[index].styleObject;
        this.clearTouchStyle();
        style.backgroundColor = this.color2rgba(style.backgroundColor, 0.5);
        cardDom.style.backgroundColor = this.color2rgba(cardDom.style.backgroundColor, 0.5);
        cardDom.removeEventListener(enums.Events.touchMove, this.bindTouchMove);
        cardDom.addEventListener(enums.Events.touchMove, this.bindTouchMove);
        this.$refs.layout.removeEventListener(enums.Events.touchMove, this.bindTouchMove);
        this.$refs.layout.addEventListener(enums.Events.touchMove, this.bindTouchMove);

        clearTimeout(this.iotsTomeOut);
        this.iotsTomeOut = setTimeout(() => {
          if (this.isOnlyTouchStart) {
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent('touchcancle', true, true);
            cardDom.dispatchEvent(evt);
          }
        }, 1000);

      },
      scrollTrigger() {
        clearTimeout(this.scrollTimeOut);
        this.scrollTimeOut = setTimeout(() => {
          this.clearTouchStyle();
          this.isShowFinger();
        }, 100)
      },
      clearTouchStyle() {
        this.cardList.forEach(card => {
          card.styleObject.backgroundColor = this.color2rgba(card.styleObject.backgroundColor, 1);
        });
        const cards = this.getCardsDoms();
        for (let i = 0, len = cards.length; i < len; i++) {
          cards[i].style.backgroundColor = this.color2rgba(cards[i].style.backgroundColor, 1);
        }
      },
      unTouchTrigger(e) {
        this.isOnlyTouchStart = false;
        this.clearTouchStyle();
        const cardDoms = this.$refs.layout.querySelector('.card-item-touch') || [];
        for (let i = 0, len = cardDoms.length; i < len; i++) {
          cardDoms[i].removeEventListener(enums.Events.touchMove, this.bindTouchMove);
        }
        this.$refs.layout.removeEventListener(enums.Events.touchMove, this.bindTouchMove);
        this.logText('.info', 'touchend');
        if (!this.isTouchMoved) {
          let cardDom = null;
          let nowDom = e.target;
          while (nowDom.className.indexOf('card-item-touch') < 0 && nowDom !== this.$refs.layout) {
            nowDom = nowDom.parentNode;
          }
          if (nowDom.className.indexOf('card-item-touch') >= 0) {
            cardDom = nowDom;
          }
          if (cardDom) {
            const index = cardDom.getAttribute('data-index');
            this.goCard(index);
          }
        }
      },
      clickCard(index) {
        this.logText('.subInfo', 'click trigger');
        setTimeout(() => {
          this.goCard(index);
        }, 150);
      },
      goCard(index) {
        const cardItem = this.cardList[index];
        const params = {
          path: cardItem.path,
          query: { type: cardItem.type, linksTo: cardItem.linksTo, name: cardItem.info }
        };
        this.routerLink(params);
      },
      isShowFinger() {
        if (this.isPc) {
          this.$store.commit('changeGestureState', false);
        } else {
          const box = this.$el.querySelector('.scroll-box');
          const inner = this.$el.querySelector('.slide-inner');
          const boxWidth = box ? box.offsetWidth : 0;
          const innerWidth = inner ? inner.offsetWidth : 0;
          const boxScrollLeft = box ? box.scrollLeft : 0;
          this.$store.commit('changeGestureState', boxWidth < innerWidth);
          if (innerWidth - (boxWidth + boxScrollLeft) < 5) {
            this.$store.commit('changeGestureState', false);
          }
        }
      },
      getSavedTrace(batchId) {
        let traceDataSave = localStorage.getItem('traceDataSave');
        let traceNodeList = null;
        if (traceDataSave) {
          traceDataSave = JSON.parse(traceDataSave);
          if (traceDataSave.batchId === batchId) {
            const now = Date.now();
            const saveTime = traceDataSave.saveTime;
            if (now - saveTime < 5 * 60 * 60 * 1000) { //5小时
              traceNodeList = traceDataSave.traceNodeList;
            }
          }
        }
        return traceNodeList;
      },
      //加载保存溯源信息
      saveTraceInfo() {
        const batchId = localStorage.getItem('traceingBatchID');
        if (batchId && batchId != '') {
          const traceNodeList = this.getSavedTrace(batchId);
          if (!traceNodeList) {
            this.$ajax.get(this.$urlAPI.BaseData.getAndroidToken).then((result) => {
              if (result.Result == 200) {
                const token = result.Data.token;
                this.$ajax.cacheJsonp(this.$urlAPI.BaseData.GetProductBatchTraceNode, {
                  ProductBatchID: batchId,
                  Token: token
                }).then((result) => {
                  if (result.Result == 200 && result.Data.TraceNodeList) {
                    const now = Date.now();
                    const saveData = { batchId: batchId, saveTime: now, traceNodeList: result.Data.TraceNodeList }
                    localStorage.setItem('traceDataSave', JSON.stringify(saveData))
                  } else {
                  }
                });
              }
            });
          }
        }
      }
    },
    created() {
      this.$store.commit('setPageTitle', '溯源结果');
      this.resetRemRootSize();
      this.dataReady = true;
      this.getData();
    },
    mounted() {
      this.bindTouch();
      this.isShowFinger();
      setTimeout(this.isShowFinger, 200);
      setTimeout(this.isShowFinger, 500);
      this.saveTraceInfo();
      this.setWeatherAllowed();
    },
    beforeDestroy() {
      this.unbindTouch();
    }
  }
</script>

<style lang="less" scoped>
  @import '../../assets/less/base.less';

  @red: #bb1d48;
  .index-layout {
    position: absolute;
    left: 0;
    right: 0;
    padding: 0 50px;
    top: 0.3rem;
    bottom: 0.3rem;
    overflow: hidden;

    .scroll-box {
      height: 100%;
      width: 100%;
      overflow: hidden;
      overflow-x: auto;
    }
    .slide-inner {
      height: 100%;
      transform: translate3d(0, 0, 0);
      overflow: hidden;
    }

    &.is-pc {
      .slide-inner {
        transform: translate3d(0, 0, 0) scale(0.92, 0.92);
        margin-left: -4%;
      }
    }

    .card-wrap {
      display: inline-block;
      vertical-align: top;
    }
  }

  .slide-detail {
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
  }

  .card-type {
    background: @red;
    font-size: @font-size-small;
  }

  .icon-customize {
    height: 60px;
    background: center center no-repeat;
    background-size: contain;
  }

  .showcase-circle {
    position: relative;
    width: 5.2rem;
    height: 5.2rem;
    margin: 15% auto 0;
    border: 0.2rem solid saturate(darken(@red, 5%), 5%);
    border-radius: 50%;
    overflow: hidden;
    z-index: 100;
    transform: translate3d(0, 0, 0);
    transform-style: preserve-3d;
    -webkit-mask-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC); /* this fixes the overflow:hidden in Chrome/Opera */
  }

  .card {
    position: relative;
    box-sizing: border-box;
    padding: 0.3rem 0.2rem;
    color: #fff;
  }

  .cardInfo {
    color: #fff;
    text-align: center;
  }

  p {
    color: #fff;
  }

  .info {
    .cardInfo;
    margin-top: 0.1rem;
  }

  .subInfo {
    .cardInfo;
    margin-top: 0.08rem;
  }

  .card-mainInfo .info {
    font-size: @font-size-normal;
    margin: 0.5rem 0.2rem 0.2rem;
  }

  .card-mainInfo .subInfo {
    padding: 0 0.2rem;
    margin: 0;
  }

  .card-controls {
    padding: 0.3rem 0.2rem;
  }

  .card-controls .left-title {
    font-size: @font-size-normal;
  }

  .card-controls .left-subTitle {
    font-size: @font-size-small;
    margin-top: 0.08rem;
  }

  .card-controls .content-image {
    height: 2.1rem;
    background: center center no-repeat;
    background-size: contain;
  }

  .card-details {
    font-size: 0;
    .card;
    overflow: hidden;
  }

  .card-details-item {
    margin-top: 8px;
  }

  .card-details .card-head {
    font-size: @font-size-normal;
    height: 1em;
    line-height: 1em;
    text-align: center;
  }

  .card-details .detail-title {
    float: left;
    width: 1.7rem;
    margin-right: 0.14rem;
    font-size: @font-size-small;
  }

  .card-details .detail-content {
    display: block;
    margin-left: 1.84rem;
    word-break: break-all;
    font-size: @font-size-small;
  }

  .card-details .card-content-withHead {
    overflow: hidden;
  }

  .card-details .card-content-fixed {
    margin-top: 0.2rem;
    height: 3rem;
    overflow: hidden;
  }

  .card-blockchain {
    font-size: 0;
    overflow-y: auto;
    left: 6rem !important;
    top: 6px !important;
    .card;
    overflow: hidden;
  }

  .card-blockchain-item {
    margin-top: 3px;
  }

  .card-blockchain .card-head {
    font-size: @font-size-normal;
    height: 1em;
    line-height: 1em;
    text-align: center;
  }

  .card-blockchain .detail-title {
    float: left;
    width: 1.7rem;
    margin-right: 0.14rem;
    font-size: @font-size-small;
  }

  .card-blockchain .detail-content {
    display: block;
    margin-left: 1.84rem;
    word-break: break-all;
    font-size: @font-size-small;
  }

  .card-blockchain .card-content-withHead {
    overflow: hidden;
  }

  .card-blockchain .card-content-fixed {
    padding: 0.2rem 0;
    height: 3rem;
    overflow: hidden;
  }

  .card-weather {
    .card;
    position: absolute;
  }

  .card-weather .content-image {
    height: 2.6rem;
    background: center center no-repeat;
    background-size: contain;
  }

  .card-weather .temperature {
    font-size: @font-size-larger;
  }

  .card-qrcode .content-image {
    height: 3.4rem;
    width: 80%;
    margin: auto;
    background: center center no-repeat;
    background-size: contain;
  }

  .center-content {
    padding: 1.26rem 0;
    text-align: center;
    vertical-align: middle;
  }

  .content-icon {
    font-size: 60px;
    margin-bottom: 0.34rem;
  }

  .card-links {
    display: block;
    font-size: @font-size-normal;
    color: #fff;
    text-decoration: none;
  }

  @media (max-width: 1440px) {
    .info {
      font-size: 13px;
    }

    .card-mainInfo .info {
      font-size: 20px;
      margin-top: 0.2rem;
    }

    .card-mainInfo .subInfo {
      font-size: 16px;
      margin-top: 0.2rem;
    }
  }

  .weather-more {
    position: absolute;
    font-size: 20px;
    color: #fff;
    right: 5px;
    top: 5px;
  }

  .blockchain-subTitle {
    font-size: 18px;
  }

  .blockchain-subTitle span {
    color: #3ea6ff;
    height: 23px;
    line-height: 23px;
  }

  .block-icon {
    background: url("../../../static/block-icon.png") no-repeat;
    background-size: 100% 100%;
    display: inline-block;
    width: 20px;
    height: 22px;
    vertical-align: middle;
  }

  .card-content .blockchain-title {
    float: left;
    width: 1.7rem;
    margin-right: 0.14rem;
    font-size: @font-size-small;
  }

  .card-content .blockchain-content {
    display: block;
    margin-left: 1.84rem;
    word-break: break-all;
    font-size: @font-size-small;
  }

  .slide-blockchain {
    overflow-x: hidden;
    overflow-y: visible;
    height: 100%;
    width: 5.8rem;
  }

  .slide-blockchain ul {
    width: 5.7rem;
  }

  .org-detail-link {
    text-decoration: underline;
  }

  .product-card-info {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// index.vue?35864bc0